module.exports = ["Gimme More!","Make Me Another!","Again!"]


//////////////////
// WEBPACK FOOTER
// ./src/scripts/data/buttons.json
// module id = 29
// module chunks = 0